import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWaiterAuth } from '../context/WaiterAuthContext';
import './WaiterLogin.css';

const WaiterLogin = () => {
  const navigate = useNavigate();
  const { login, loginWithPIN } = useWaiterAuth();
  const [loginMode, setLoginMode] = useState('email'); // 'email' or 'pin'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError('Please enter email and password');
      return;
    }
    setLoading(true);
    setError('');

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate('/waiter/order-line');
    } else {
      setError(result.error || 'Invalid email or password');
    }
  };

  const handlePINLogin = async () => {
    if (pin.length !== 4) {
      setError('Enter 4-digit PIN');
      return;
    }
    setLoading(true);
    setError('');

    const result = await loginWithPIN(pin);
    setLoading(false);

    if (result.success) {
      navigate('/waiter/order-line');
    } else {
      setError('Invalid PIN');
      setPin('');
    }
  };

  return (
    <div className="waiter-login-container">
      <div className="login-card">
        <h1>🍽️ Odisha Zaika</h1>
        <h2>Waiter Login</h2>

        {/* Login Mode Toggle */}
        <div className="login-mode-toggle">
          <button
            className={loginMode === 'email' ? 'active' : ''}
            onClick={() => { setLoginMode('email'); setError(''); setPin(''); }}
          >
            Email/Password
          </button>
          <button
            className={loginMode === 'pin' ? 'active' : ''}
            onClick={() => { setLoginMode('pin'); setError(''); setEmail(''); setPassword(''); }}
          >
            Quick PIN
          </button>
        </div>

        {error && <div className="error">{error}</div>}

        {/* Email/Password Login Form */}
        {loginMode === 'email' && (
          <form onSubmit={handleEmailLogin} className="email-login-form">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                disabled={loading}
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                disabled={loading}
              />
            </div>
            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        )}

        {/* PIN Login Interface */}
        {loginMode === 'pin' && (
          <div className="pin-login">
            <div className="pin-display">
              {[0,1,2,3].map(i => (
                <span key={i} className="pin-dot">
                  {pin.length > i ? '●' : '○'}
                </span>
              ))}
            </div>
            <div className="pin-pad">
              {[1,2,3,4,5,6,7,8,9].map(num => (
                <button
                  key={num}
                  onClick={() => pin.length < 4 && setPin(pin + num)}
                  disabled={loading}
                >
                  {num}
                </button>
              ))}
              <button onClick={() => setPin('')} disabled={loading}>Clear</button>
              <button onClick={() => pin.length < 4 && setPin(pin + '0')} disabled={loading}>0</button>
              <button onClick={handlePINLogin} disabled={loading} className="btn-pin-login">
                {loading ? '...' : 'Login'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WaiterLogin;